import { BASE_URL, FIELD_MASTER_PROJECTIONS } from "../config";
import { getSessionId } from "../utils/SessionHandler";
import { handleResponse } from "./responseHandler";

function authHeaders() {
  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${getSessionId()}`,
  };
}

export function getProjectionErrorMessage(response, fallback) {
  if (!response || typeof response !== "object") return fallback;
  return (
    response.description ||
    response.message ||
    response.error?.description ||
    fallback
  );
}

export function isProjectionError(response) {
  return (
    !response ||
    typeof response !== "object" ||
    Boolean(response.error) ||
    (typeof response.description === "string" && response.description) ||
    (typeof response.message === "string" && response.message)
  );
}

export async function fetchProjectionOptions(tranCode) {
  const response = await fetch(
    `${BASE_URL}${FIELD_MASTER_PROJECTIONS}/${encodeURIComponent(tranCode)}/options`,
    { method: "GET", headers: authHeaders() },
  );
  return handleResponse(response);
}

export async function fetchProjections(tranCode) {
  const response = await fetch(
    `${BASE_URL}${FIELD_MASTER_PROJECTIONS}/${encodeURIComponent(tranCode)}`,
    { method: "GET", headers: authHeaders() },
  );
  return handleResponse(response);
}

export async function createProjection(payload) {
  const response = await fetch(`${BASE_URL}${FIELD_MASTER_PROJECTIONS}`, {
    method: "POST",
    headers: authHeaders(),
    body: JSON.stringify(payload),
  });
  return handleResponse(response);
}

export async function updateProjection(id, payload) {
  const response = await fetch(
    `${BASE_URL}${FIELD_MASTER_PROJECTIONS}/${id}/update`,
    {
      method: "POST",
      headers: authHeaders(),
      body: JSON.stringify(payload),
    },
  );
  return handleResponse(response);
}

export async function activateProjection(id) {
  const response = await fetch(
    `${BASE_URL}${FIELD_MASTER_PROJECTIONS}/${id}/activate`,
    { method: "POST", headers: authHeaders() },
  );
  return handleResponse(response);
}

export async function deactivateProjection(id) {
  const response = await fetch(
    `${BASE_URL}${FIELD_MASTER_PROJECTIONS}/${id}/deactivate`,
    { method: "POST", headers: authHeaders() },
  );
  return handleResponse(response);
}

export async function deleteProjection(id) {
  const response = await fetch(
    `${BASE_URL}${FIELD_MASTER_PROJECTIONS}/${id}/delete`,
    { method: "POST", headers: authHeaders() },
  );
  return handleResponse(response);
}
